export default "__VITE_ASSET__DYtRqisx__"